import React from "react";
import AssignmentCard from "./AssignmentCard";
import ClassroomMenu from "./ClassroomMenu";
import { formatExamBoard } from "../Components/examBoards";

/**
 * A classroom on the dashboard (Figma 72:109, 114:50): the subject code in the
 * pill, the classroom name, the board and qualification on one line separated
 * by a dot, and for the teacher a "..." menu in the corner. Shares the
 * assignment card shell so both lists read as one system.
 */
const ClassroomCard = ({
  subjectCode,
  classroomName,
  qualificationCode,
  boardName,
  typeOfUser,
  onClick,
  /** Teacher only: deleting is offered when this is given. */
  onDelete,
  /** Teacher only: how this classroom's marking stands. */
  footer,
  isDark,
}) => (
  <AssignmentCard
    statusLabel={subjectCode}
    statusTone="none"
    title={classroomName}
    tags={[formatExamBoard(boardName), qualificationCode]}
    onClick={onClick}
    footer={footer}
    cornerAction={
      typeOfUser === "INSTRUCTOR" && onDelete ? (
        <ClassroomMenu classroomName={classroomName} isDark={isDark} onOpen={onClick} onDelete={onDelete} />
      ) : null
    }
  />
);

export default ClassroomCard;
